<template>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <div id="menu-bar">
    <ul>
      <li><router-link to="/">About</router-link></li>
      <li><a href="https://humane-epoxy-35d.notion.site/This-is-Project-Page-17eb8eb9f22880f08fefdff575c78ce7?pvs=74">Project</a></li>

      <li><a href="https://velog.io/@gimseonmo">Blog</a></li>
    </ul>

  </div>


  <div id="profile">
    <img id="profile-img" src="src/img/profile.jpg" alt="Profile Image">
    <div id="profile-text">
      <h1 style="font-size:45px">This is Main Page</h1>
      <router-view></router-view>
      <h3 style="margin-left:5px">김선모 포트폴리오 사이트</h3>
      <div id="profile-userurl" style="margin-left:5px">
        <a href="https://velog.io/@gimseonmo">Velog</a>
        <a href="https://github.com/gimseonmo">Github</a>
        <a href="https://solved.ac/profile/gimseonmo">BOJ (Solved.ac)</a>
        <a href="https://dreamhack.io/users/44057">Dreamhack</a>
        <a href="https://www.instagram.com/eowonnd/">Instagram</a>
      </div>
    </div>
  </div>
  
  <div>
    <br>
    
  </div>
  <div>
  <div id="Education">
    <h1>Education.</h1>
  </div>
  <hr>
  <div>
  <div v-for="(item, index) in Education_items_names" :key="index" id="Education-items">
    <img :src="'src/img/education/'+index+'.png'" alt="pictures">
    <div>
    <h1 id="name">{{item}}</h1>
    <span id="explain">{{Education_items_explain[index]}}</span>
    <br>
    <span id="period">{{Education_items_period[index]}}</span>
    </div>
  </div>
</div>
</div>

  <div>
  <div id="Education">
    <h1>Award.</h1>
  </div>
  <hr>
  <div>
  <div v-for="(item, index) in Award_items_names" :key="index" id="Education-items">
    <img style="background-color: white;" :src="'src/img/award/'+index+'.png'" alt="picture">
    <div>
    <h1 id="name">{{item}}</h1>
    <span id="explain">{{Award_items_period[index]}}</span>
    <br>
    <span id="period">{{Award_items_explain[index]}}</span>
    </div>
  </div>
</div>
</div>
</template>

<script>

  // 페이지가 로드되었을 때 실행되는 함수
  window.addEventListener('scroll', function() {
    var menuBar = document.getElementById('menu-bar');

    // 현재 스크롤 위치가 0보다 큰 경우 그림자 효과를 추가
    if (window.scrollY > 0) {
      menuBar.classList.add('shadow');
    } else {
      // 스크롤 위치가 0일 경우 그림자 효과를 제거
      menuBar.classList.remove('shadow');
    }
  });


export default {
  name: 'App',
  data() {
    return {
      Education_items_names : [
        "상당중학교",
        "부산권 정보보호영재교육원",
        "신도고등학교",
        "INGENIOUS",
        "Supercomputing Youth Camp 2025"
      ],
      Education_items_explain : [
        "2022.03.02 - 2025.02.28",
        "중등기초반 수료",
        "2025.03.04 - ",
        "신도고등학교 프로그래밍 동아리",
        "울산과학기술원 & 한국과학기술정보연구원 주최"
      ],
      Education_items_period : [
        "",
        "2023. 04 - 2023. 11. 18",
        "",
        "2025. 03. 11 - ",
        "2025.07.28 - 2025.08.01", 
      ],
      Award_items_names : [
        "2023년 부산 SWㆍAI 교육 중등학생 해카톤 대회 우수상",
        "2023년 부산권 정보보호영재교육원 최우수상 (1등)",
        "2024 ICT Award Korea 알고리즘 중등부 장려상 (전국 10등)",
        "동래메이커교육체험센터 제1회 메이커톤 우수상",
        "2024년 부산 SWㆍAI 융합 해카톤 대회 장려상",
        "제6회 전국 중학생 알고리즘 경진대회 동상 (전국 4등)",
        "제18회 i-TOP 경진대회 SW코딩분야 대학총장상",
        "제6회 한국코드페어 SW공모전 중등부 동상",
        "제10회 AI·SW 융합 해커톤 고등부 우수상"
      ],
      Award_items_period : [
        "부산광역시교육청교육연구정보원 원장상",
        "부산광역시 시장상",
        "한국정보과학진흥협회 이사장상",
        "부산광역시창의융합교육원 원장상",
        "부산광역시교육청교육연구정보원 원장상",
        "대덕소프트웨어마이스터고등학교장상",
        "동명대학교 총장상",
        "한국정보과학회 회장상",
        "부산정보산업진흥원 원장상"
      ],
      Award_items_explain : [
        "2023. 07. 27",
        "2023. 11. 18",
        "2024. 06. 15",
        "2024. 07. 14",
        "2024. 07. 31",
        "2024. 09. 28",
        "2024. 10. 05",
        "2024. 10. 26",
        "2025. 07. 11"
      ],  


    }
  }
}
</script>

<style>

/* 전체 스타일 초기화 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
/* 이미지 스타일링 */
#profile-img {
  border-radius: 2000%; /* 원형으로 만들기 */
  height: 160px; /* 이미지 높이 설정 */
  width: 160px; /* 이미지 너비 설정 */
}

#Education-items {
  display: flex; /* flexbox 사용 */
  align-items: center; /* 수직 가운데 정렬 */
  gap: 2%; /* 이미지와 텍스트 사이의 간격 설정 */
  margin-left: 20%; /* 왼쪽 여백 조정 (필요에 따라 조정) */
  padding: 1%; /* 내부 여백 추가 */
  color: white; /* 텍스트 색상을 흰색으로 설정 */
  flex-wrap: wrap; /* 줄바꿈을 허용 */
  max-width: 100%; /* 최대 너비 설정 */
}

#Education-items h1 {
  text-align: left;
  font-size: 190%; /* 텍스트 크기 조정 */
  white-space: nowrap; /* 텍스트 줄바꿈 방지 */
  text-overflow: ellipsis; /* 말줄임표(...) 추가 */
  max-width: 100%; /* 최대 너비 설정 */
}

#Education-items span {
  margin-left: 0%;
  font-size: 16px; /* 텍스트 크기 조정 */
  word-wrap: break-word; /* 긴 단어를 줄바꿈하여 표시 */
}

#Education-items img {
  border-radius: 12px; /* 이미지 둥글기 조정 */
  height: 9%; /* 이미지 높이 설정 */
  width: 9%; /* 이미지 너비 설정 */
}


hr {
  width: 60%; /* 원하는 너비 설정 (100%는 전체 너비) */
  margin: 5% auto; /* 위아래 여백을 설정하고 좌우 가운데 정렬 */
  border: 1% solid #888; /* 선 스타일 (필요에 따라 조정) */
  border-bottom: 0px;
}

/* 바디 스타일링 */
body {
  background-color: #212529; /* 배경색 설정 */
  position: relative;
}

#Education {
  display: flex; /* flexbox를 사용하여 요소 정렬 */
  align-items: center; /* 수직 가운데 정렬 */
  gap: 20px; /* 이미지와 텍스트 사이의 간격 설정 */
  margin-left: 20%;
  font-size: 20px;
  padding: 20px; /* 내부 여백 추가 */
  color: white; /* 텍스트 색상을 흰색으로 설정 */
  position: relative; /* 절대 위치 지정 */

}

/* #profile 스타일링 */
#profile {
  margin-top: 10%;
  display: flex; /* flexbox를 사용하여 요소 정렬 */
  align-items: center; /* 수직 가운데 정렬 */
  gap: 2.5%; /* 이미지와 텍스트 사이의 간격 설정 */
  margin-left: 20%;
  padding: 2%; /* 내부 여백 추가 */
  min-height: 112px; /* 최소 높이 설정 */
  color: white; /* 텍스트 색상을 흰색으로 설정 */
  position: relative; /* 절대 위치 지정 */
}

h4 {
  color: rgb(106, 103, 103);
}

/* 프로필 텍스트 스타일링 */
#profile-text {
  display: flex; /* flexbox를 사용하여 요소 정렬 */
  flex-direction: column; /* 세로 방향으로 정렬 */
  gap: 5px; /* 텍스트 간의 간격 설정 */
}
#menu-bar ul li a {
  text-decoration-line: none;
  color: white;
}
/* 프로필 사용자 이름 스타일링 */
#profile-userurl a {
  padding: 3px;
  text-decoration-line: none;
  color:#888686;
  transition: color 0.3s ease;

}

#profile-userurl a:hover {
  color: #f0f0f0; /* 마우스를 올렸을 때 색상 변경 */
}

/* 메뉴 바 스타일링 */
#menu-bar {
  height: 60px;
  width: 100%; /* 화면 전체 너비 차지 */
  display: flex;
  justify-content: flex-end; /* 오른쪽 정렬 */
  align-items: center; /* 수직 가운데 정렬 */
  padding-right: 100px; /* 오른쪽 여백 추가 */
  position: fixed; /* 화면에 고정 */
  top: 0; /* 상단에 위치 */
  left: 0; /* 왼쪽에 위치 */
  background-color: #212529; /* 배경색 추가 */
  z-index: 1000; /* 다른 요소 위에 표시되도록 설정 */
  
  border-bottom-left-radius: 15px; /* 왼쪽 아래 모서리 둥글게 */
  border-bottom-right-radius: 15px; /* 오른쪽 아래 모서리 둥글게 */
  transition: box-shadow 0.3s ease;
}
  #menu-bar.shadow {
    box-shadow: 0px 4px 8px rgba(121, 121, 121, 0.3); /* 그림자 효과 */
    background-color: #1d2124;
  }
/* 메뉴 리스트 스타일링 */
#menu-bar ul {
  list-style-type: none;
  display: flex;
  gap: 20px; /* 메뉴 항목 사이의 간격 설정 */
  margin: 0;
}

/* 메뉴 항목 스타일링 */
#menu-bar li {
  position: relative; /* 절대 위치 지정된 자식 요소를 위한 기준 설정 */
  color: white; /* 텍스트 색상 흰색으로 설정 */
  cursor: pointer; /* 커서를 포인터로 변경 */
  font-size: 18px; /* 폰트 크기 설정 */
  font-weight: bold; /* 폰트 굵기 설정 */
  padding: 10px; /* 내부 여백 추가 */
  transition: filter 0.3s ease, background 0.3s ease; /* 필터와 배경 전환 추가 */
}

/* 메뉴 항목에 마우스를 올렸을 때 스타일링 */
#menu-bar li::before {
  content: ''; /* 내용 없음 */
  position: absolute; /* 절대 위치 지정 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(136, 136, 136, 0.2); /* 반투명 배경 */
  filter: blur(3px); /* 흐림 효과 추가 (조정값) */
  border-radius: 8px; /* 둥글기 조정 */
  z-index: -1; /* 텍스트가 흐림 효과 위에 오도록 설정 */
  opacity: 0; /* 시작 시 투명하게 설정 */
  transition: opacity 0.2s ease, background 0.4s ease; /* 투명도 전환과 배경 전환 추가 */
}

/* 메뉴 항목에 마우스를 올렸을 때 투명도 변화 */
#menu-bar li:hover::before {
  opacity: 1; /* 호버 시 반투명 배경 보이게 설정 */
  transition-delay: 0.1s; /* 호버 후 0.5초 뒤에 나타나도록 설정 */
}

/* 제목 스타일링 */
hr {
  width: 60%; /* 너비 조정 */
  margin: 10px auto; /* 가운데 정렬 및 여백 추가 */
  border: 1px solid #888; /* 선 스타일 */
  border-bottom: none; /* 아래쪽 경계선 제거 */
}
/* 모바일 스타일 적용 */

@media only screen and (max-width: 600px) {
  /* 메뉴 바 스타일링 */
  #menu-bar {
    height: 80px;
    padding-right: 20px; /* 오른쪽 여백 축소 */
    border-bottom-left-radius: 20px; /* 아래쪽 라운딩 */
    border-bottom-right-radius: 20px; /* 아래쪽 라운딩 */
  }
  
  #menu-bar ul {
    gap: 10px; /* 메뉴 항목 간 간격 축소 */
  }

  #menu-bar li {
    font-size: 18px; /* 폰트 크기 조정 */
    padding: 5px; /* 내부 여백 유지 */
  }

  /* 프로필 이미지와 텍스트 정렬 */
  #profile {
    display: flex;
    flex-direction: column; /* 세로로 정렬 */
    align-items: center; /* 중앙 정렬 */
    padding-left: 100px; /* 프로필 div에서만 패딩 제거 */
    margin: 100px; /* 모든 마진 제거 */
  }

  #profile-img {
    height: 120px; /* 이미지 높이 조정 */
    width: 120px; /* 이미지 너비 조정 */
    margin: 0 0 10px 0; /* 이미지 하단 간격만 추가 */
  }

  #profile-text {
    text-align: center; /* 텍스트 가운데 정렬 */
    padding-left: -10px;
    width: 390px; /* 텍스트가 전체 너비 차지 */
    margin: 0; /* 모든 마진 제거 */
  }

  #profile-text h1 {
    font-size: 25px; /* 텍스트 크기 조정 */
  }

  #profile-text h3 {
    font-size: 16px; /* 텍스트 크기 조정 */
  }

  #profile-userurl {
    margin: 10px 0 0 0; /* 상단 간격만 추가 */
    display: flex;
    justify-content: center; /* 링크를 가운데 정렬 */
    flex-wrap: wrap; /* 줄바꿈 허용 */
    gap: 10px; /* 링크 간 간격 설정 */
  }

  #profile-userurl a {
    padding: 0;
    font-size: 14px; /* 링크 텍스트 크기 조정 */
  }

  /* Education and Award items 스타일링 */
  #Education-items {
    display: flex; 
    flex-direction: row; /* 가로 정렬로 변경 */
    align-items: center; /* 이미지와 텍스트를 세로로 중앙 정렬 */
    justify-content: flex-start; /* 콘텐츠를 왼쪽으로 정렬 */
    margin: 0; /* 모든 마진 제거 */
    padding:3%; /* 일부 패딩 유지 */
  }

  #Education {
    margin: 0;
    padding: -10%;
  }

  #Education-items img {
    height: 80px; /* 이미지 높이 축소 */
    width: 80px; /* 이미지 너비 축소 */
    margin-right: 10px; /* 이미지와 텍스트 사이 간격 추가 */
  }

  #Education-items h1 {
    font-size: 18px; /* 텍스트 크기 조정 */
    max-width: none; /* 최대 너비 제한 제거 */
    margin: 0; /* 마진 제거 */
  }

  #Education-items span {
    font-size: 14px; /* 텍스트 크기 조정 */
    margin: 0; /* 마진 제거 */
  }

  /* hr 스타일링 */
  hr {
    width: 120%; /* 모바일 화면에서 너비를 증가 */
    margin: 10px auto; /* 모바일에서도 중앙 정렬 */
    border: 0.5px solid #888; /* 선 두께 조정 */
    border-bottom: none; /* 아래쪽 경계선 제거 */
  }
}

</style>
